import { IDropdownOption, ITextFieldStyles } from '@fluentui/react'
import { IAccount } from 'api/account.types'
import { format } from 'date-fns'
import { IAdvisorAccountsByClientId } from 'modules/ReconAIDataQuality/api/types'
import { isDefined } from 'shared/gaurds'
import { IDomainItem } from 'store/context/domain'

export const getClientOptions = (
  clientSearchResults?: any[],
  PartyUniqueId?: string,
  clientName?: string
) => {
  const clientData: IDropdownOption[] | undefined = clientSearchResults
    ?.filter(
      (value, index, self) =>
        isDefined(value.PartyUniqueId) &&
        index ===
          self.findIndex(
            (t) =>
              t.PartyUniqueId === value.PartyUniqueId &&
              t.LegalEntityName === value.LegalEntityName
          )
    )
    .map(
      (x: any) =>
        ({
          key: x.PartyUniqueId,
          text: `${x.LegalEntityName} (${x.PartyUniqueId})`
        } as IDropdownOption)
    )
  return clientSearchResults?.find(
    (x: any) => x.PartyUniqueId === PartyUniqueId
  ) === undefined &&
    PartyUniqueId !== undefined &&
    clientName !== undefined &&
    clientData
    ? [
        {
          key: PartyUniqueId as string,
          text: clientName
        } as IDropdownOption
      ].concat(clientData)
    : clientData
}
export const getExistedAccNoOptions = (
  accountNumberList?: IAccount[],
  advisorAccountByClientId?: IAdvisorAccountsByClientId[]
) => {
  const accNoList1 =
    accountNumberList?.map(
      (x: any) =>
        ({
          key: x.CustodyAccount,
          text: x.CustodyAccount
        } as IDropdownOption)
    ) || []

  const accNoList2 =
    advisorAccountByClientId?.map(
      (x: any) =>
        ({
          key: x.accNo,
          text: x.accNo
        } as IDropdownOption)
    ) || []

  const uniqueValues = [...new Set([...accNoList1, ...accNoList2])]

  return uniqueValues
}
export enum AccountSource {
  FSA,
  Tamarac,
  Addepar,
  SATool
}

export const accountSourceArray: string[] = Object.keys(AccountSource).filter(
  (key) => isNaN(Number(key))
)

export enum RCMCDStatus {
  ACTIVE = 'Active',
  CANCELLED = 'Cancelled',
  COMPLETE = 'Complete'
}
export const convertToUSD = (data: number | undefined): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })

  return data ? formatter.format(data) : '$0'
}
export const dateFormat = (date: Date) =>
  new Date(date)?.toLocaleDateString('en-US')
export const formatDateString = (date: string | undefined): string => {
  const formattedString = ''
  try {
    if (date) {
      return format(new Date(date || ''), 'MM/dd/yyyy')
    }
  } catch {
    return formattedString
  }
  return formattedString
}

export const getAdvisorOptions = (
  advisorSearchResults?: IDomainItem[],
  advisorId?: string,
  advisorName?: string
) => {
  const advisorData: IDropdownOption[] | undefined = advisorSearchResults?.map(
    (x: any) =>
      ({
        key: x.ClientAdvisorID,
        text: x.ClientAdvisorID + ' - ' + x.ClientAdvisor
      } as IDropdownOption)
  )
  return advisorSearchResults?.find(
    (x: any) => x.ClientAdvisorID === advisorId
  ) === undefined &&
    advisorId !== undefined &&
    advisorName !== undefined &&
    advisorData
    ? [
        {
          key: advisorId as string,
          text: advisorId + ' - ' + advisorName
        } as IDropdownOption
      ].concat(advisorData)
    : advisorData
}

export const getAdvisorName = (
  advisorSearchResults?: IDomainItem[],
  advisorId?: string
) => {
  const advisorName: string | undefined = advisorSearchResults?.find(
    (x: IDomainItem) => x.ClientAdvisorID === advisorId
  )?.ClientAdvisor

  return advisorName && `${advisorId} - ${advisorName}`
}

export function getEnumKeyByEnumValue<T extends { [index: string]: string }>(
  myEnum: T,
  enumValue: string
): keyof T | null {
  const keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue)
  return keys.length > 0 ? keys[0] : null
}

export const formatReconStatusLabel = (
  status?: string | null
): string | undefined => {
  if (!status) {
    return undefined
  }

  return status.toLowerCase() === 'inprogress' ? 'In Progress' : status
}

export const textAreaStyles: Partial<ITextFieldStyles> = {
  root: {
    minWidth: 360
  },
  fieldGroup: {
    padding: '21 16',
    border: '1px solid rgba(31, 31, 31, 0.20)',
    background: '#FAFAFA',
    fontSize: 50,
    fornWeight: 400
  }
}
export const allowedUploadedAllocationTypes: string[] = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/csv',
  'application/vnd.ms-excel',
  'text/csv'
]

export enum ReconActiveTabsEnum {
  InProgress = 'InProgress',
  AssignedToMe = 'Assigned To Me',
  Resolved = 'Resolved',
  All = 'All',
  Suppressed = 'Suppressed',
  New = 'New',
  NULL = 'NULL'
}

export enum ReconEventCodesEnum {
  ADD_COMMENT = 'AC',
  ASSIGN_BREAK = 'AB',
  SUPPRESS_BREAKS = 'SB',
  SUPPRESS_BREAKS_5DAYS = 'SB5',
  UNSUPPRESS_BREAKS = 'USB',
  RESOLVED_BREAKS = 'RS',
  NULL = 'NULL'
}
export const BREAKDETAILPERCENTAGEATTR = [
  'TWRRANNRET',
  'TWRRCUMRET',
  'NETIRRCUM',
  'NETIRRANN'
]
export const SUCCESS_TIMEOUT = 2000
export const colors = [
  '#7BC46C',
  '#B0D6F1',
  '#005CB8',
  '#7C858C',
  '#B3E3F4',
  '#B2B3B2',
  '#C6E0F2',
  '#13A5B0',
  '#45BEAA',
  '#C4E1B2',
  '#EF4264',
  '#B71F3A',
  '#F4B93F',
  '#06262D',
  '#F89938',
  '#B02C91',
  '#653C93',
  '#3E8DDD',
  '#57C8E7',
  '#5C666F',
  '#D1D3D3',
  '#B3E3F4',
  '#45BEAA',
  '#7BC46C',
  '#C4E1B2',
  '#324B53',
  '#2A769D',
  '#13272B',
  '#EAF6FC',
  '#F5F5F5',
  '#008000'
]
